const KEY = "sprout-attribution";

// First-touch capture of tagged links (utm_*) and external referrers; a new tagged visit replaces older data.
export function captureAttribution() {
  try {
    const p = new URLSearchParams(window.location.search);
    const utm = { utm_source: p.get("utm_source"), utm_medium: p.get("utm_medium"), utm_campaign: p.get("utm_campaign") };
    const ref = document.referrer && !document.referrer.startsWith(window.location.origin) ? document.referrer : null;
    const existing = JSON.parse(localStorage.getItem(KEY) || "null");
    if (utm.utm_source) {
      localStorage.setItem(KEY, JSON.stringify({ ...utm, referrer: ref }));
    } else if (!existing && ref) {
      localStorage.setItem(KEY, JSON.stringify({ referrer: ref }));
    }
  } catch {
    /* storage unavailable */
  }
}

export function getAttribution() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null") || undefined;
  } catch {
    return undefined;
  }
}
